import { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Grid, Icon, Paper } from '@mui/material';
import { useIntl } from 'react-intl';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';

// Composant InlineIconSelector
function InlineIconSelector({ value, onChange }) {
  const [showIcons, setShowIcons] = useState(false);
  const { formatMessage: msg } = useIntl();

  // Icônes Material-UI courantes
  const commonIcons = [
    'home',
    'assistant_rounded',
    'business',
    'school',
    'work',
    'shopping_cart',
    'settings',
    'person',
    'folder',
    'description',
    'date_range',
    'account_circle',
    'email',
    'phone',
    'chat',
    'favorite',
    'star',
    'location_on',
    'dashboard',
    'notifications',
    'security',
    'build',
    'help'
  ];

  return (
    <MDBox sx={{ mb: 2 }}>
      <MDBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 1
        }}
      >
        <MDTypography variant="subtitle2">
          {msg({ id: 'field.icon.label' }) || 'Icône'}
        </MDTypography>
        <MDBox
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: (theme) => theme.palette.grey[200],
            cursor: 'pointer',
            border: value ? '2px solid' : 'none',
            borderColor: (theme) => theme.palette.primary.main
          }}
          onClick={() => setShowIcons(!showIcons)}
        >
          {value ? (
            <Icon>{value}</Icon>
          ) : (
            <MDTypography variant="body2" color="text">
              +
            </MDTypography>
          )}
        </MDBox>
      </MDBox>

      <Collapse in={showIcons}>
        <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
          <Grid container spacing={1} sx={{ maxHeight: '200px', overflow: 'auto' }}>
            {commonIcons.map((iconName) => (
              <Grid item key={iconName} xs={3} sm={2} md={1}>
                <MDBox
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1,
                    borderRadius: 1,
                    cursor: 'pointer',
                    bgcolor:
                      value === iconName
                        ? (theme) => `${theme.palette.primary.main}20`
                        : 'rgba(0, 0, 0, 0)',
                    '&:hover': {
                      backgroundColor: (theme) => theme.palette.grey[200]
                    }
                  }}
                  onClick={() => {
                    onChange(iconName);
                    setShowIcons(false);
                  }}
                >
                  <Icon sx={{ mb: 0.5 }}>{iconName}</Icon>
                </MDBox>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Collapse>
    </MDBox>
  );
}

InlineIconSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default InlineIconSelector;
